import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/adapters.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import * as api from '@gmini/sm-api-sdk';
export function adapter(source) {
  var apiEntityType = source.type;
  var fn = adapters[apiEntityType]; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return fn(source);
}
var adapters = {
  BaseClassifier: function (_BaseClassifier) {
    function BaseClassifier(_x) {
      return _BaseClassifier.apply(this, arguments);
    }

    BaseClassifier.toString = function () {
      return _BaseClassifier.toString();
    };

    return BaseClassifier;
  }(function (source) {
    return _objectSpread({
      type: 'BaseClassifierNode',
      version: source.version,
      offset: 0,
      children: [],
      projectUrn: source.projectUrn
    }, pickEntityProps(source));
  }),
  BaseClassifierPopulated: function BaseClassifierPopulated(source) {
    return _objectSpread({
      type: 'BaseClassifierNode',
      version: source.version,
      offset: source.offset,
      children: source.children.map(ref),
      projectUrn: source.projectUrn
    }, pickEntityProps(source));
  },
  UserClassifier: function (_UserClassifier) {
    function UserClassifier(_x2) {
      return _UserClassifier.apply(this, arguments);
    }

    UserClassifier.toString = function () {
      return _UserClassifier.toString();
    };

    return UserClassifier;
  }(function (source) {
    return _objectSpread({
      type: 'UserClassifierNode',
      version: source.version,
      offset: 0,
      children: [],
      parentFolderId: source.parentFolderId,
      readOnly: source.readOnly,
      owner: source.owner,
      versionNameOwner: source.versionNameOwner,
      versionCreatedDate: source.versionCreatedDate,
      versionName: source.versionName,
      sourceClassifiers: source.sourceClassifiers.map(ref),
      projectUrn: source.projectUrn
    }, pickEntityProps(source));
  }),
  UserClassifierPopulated: function UserClassifierPopulated(source) {
    return _objectSpread({
      type: 'UserClassifierNode',
      version: source.version,
      offset: source.offset,
      children: source.children.map(ref),
      parentFolderId: source.parentFolderId,
      versionNameOwner: source.versionNameOwner,
      versionCreatedDate: source.versionCreatedDate,
      versionName: source.versionName,
      readOnly: source.readOnly,
      owner: source.owner,
      sourceClassifiers: source.sourceClassifiers.map(ref),
      projectUrn: source.projectUrn
    }, pickEntityProps(source));
  },
  AssemblyClassifier: function (_AssemblyClassifier) {
    function AssemblyClassifier(_x3) {
      return _AssemblyClassifier.apply(this, arguments);
    }

    AssemblyClassifier.toString = function () {
      return _AssemblyClassifier.toString();
    };

    return AssemblyClassifier;
  }(function (source) {
    return _objectSpread({
      type: 'AssemblyClassifierNode',
      version: source.version,
      offset: 0,
      children: [],
      assemblyModelRef: source.assemblyModelRef ? adapter(source.assemblyModelRef) : null,
      parentFolderId: source.parentFolderId,
      readOnly: source.readOnly,
      owner: source.owner,
      versionNameOwner: source.versionNameOwner,
      versionCreatedDate: source.versionCreatedDate,
      versionName: source.versionName,
      sourceClassifiers: source.sourceClassifiers.map(ref),
      status: source.status,
      projectUrn: source.projectUrn
    }, pickEntityProps(_objectSpread(_objectSpread({}, source), {}, {
      total: 0
    })));
  }),
  AnonymousClassifier: function (_AnonymousClassifier) {
    function AnonymousClassifier(_x4) {
      return _AnonymousClassifier.apply(this, arguments);
    }

    AnonymousClassifier.toString = function () {
      return _AnonymousClassifier.toString();
    };

    return AnonymousClassifier;
  }(function (source) {
    return _objectSpread({
      type: 'AnonymousClassifierNode',
      version: source.version,
      offset: 0,
      children: [],
      parentFolderId: source.parentFolderId,
      readOnly: source.readOnly,
      owner: source.owner,
      versionNameOwner: source.versionNameOwner,
      versionCreatedDate: source.versionCreatedDate,
      versionName: source.versionName,
      sourceClassifiers: source.sourceClassifiers.map(ref),
      componentId: source.componentId,
      componentType: source.componentType,
      projectUrn: source.projectUrn
    }, pickEntityProps(source));
  }),
  DynamicBaseGroup: function (_DynamicBaseGroup) {
    function DynamicBaseGroup(_x5) {
      return _DynamicBaseGroup.apply(this, arguments);
    }

    DynamicBaseGroup.toString = function () {
      return _DynamicBaseGroup.toString();
    };

    return DynamicBaseGroup;
  }(function (source) {
    return {
      type: 'DynamicBaseGroupNode',
      offset: 0,
      children: [],
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      sourceGroupId: source.sourceGroupId,
      parentDynamicGroupId: source.parentDynamicGroupId,
      groupingConditions: source.groupingConditions,
      id: source.id,
      name: source.name,
      // TODO GT-1136 Front: Хранение списка динамических групп на фронте, выпилить total из динамических групп
      // Сейчас мы не можем выпилить total так как нам не известен весь список динамических групп, с бэка total приходит только в populated сущностях динамических групп
      total: 1
    };
  }),
  DynamicBaseGroupPopulated: function DynamicBaseGroupPopulated(source) {
    return _objectSpread({
      type: 'DynamicBaseGroupNode',
      offset: 0,
      children: source.children.map(ref),
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      sourceGroupId: source.sourceGroupId,
      parentDynamicGroupId: source.parentDynamicGroupId,
      groupingConditions: source.groupingConditions
    }, pickEntityProps(source));
  },
  DynamicGeneratedGroup: function (_DynamicGeneratedGroup) {
    function DynamicGeneratedGroup(_x6) {
      return _DynamicGeneratedGroup.apply(this, arguments);
    }

    DynamicGeneratedGroup.toString = function () {
      return _DynamicGeneratedGroup.toString();
    };

    return DynamicGeneratedGroup;
  }(function (source) {
    return {
      type: 'DynamicGeneratedGroupNode',
      children: [],
      offset: 0,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentDynamicGroupId: source.parentDynamicGroupId,
      source: source.source,
      id: source.id,
      name: source.name,
      // TODO GT-1136 Front: Хранение списка динамических групп на фронте, выпилить total из динамических групп
      // Сейчас мы не можем выпилить total так как нам не известен весь список динамических групп, с бэка total приходит только в populated сущностях динамических групп
      total: 1,
      filter: source.filter
    };
  }),
  DynamicGeneratedGroupPopulated: function DynamicGeneratedGroupPopulated(source) {
    return _objectSpread({
      type: 'DynamicGeneratedGroupNode',
      //TODO children DynamicGroup[] | DynamicBimElementReference[]
      children: source.children.map(ref),
      offset: source.offset,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentDynamicGroupId: source.parentDynamicGroupId,
      source: source.source,
      filter: source.filter
    }, pickEntityProps(source));
  },
  DynamicBimElementReference: function (_DynamicBimElementReference) {
    function DynamicBimElementReference(_x7) {
      return _DynamicBimElementReference.apply(this, arguments);
    }

    DynamicBimElementReference.toString = function () {
      return _DynamicBimElementReference.toString();
    };

    return DynamicBimElementReference;
  }(function (source) {
    return _objectSpread(_objectSpread({}, source), {}, {
      type: 'DynamicBimElementReferenceNode',
      parentGroupId: source.parentDynamicGroupId,
      element: ref(source.element)
    });
  }),
  UserClassifierGroupWithGroups: function UserClassifierGroupWithGroups(source) {
    return _objectSpread({
      type: 'UserClassifierGroupWithGroupsNode',
      offset: 0,
      children: [],
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      source: source.source,
      dynamicGroup: source.dynamicGroup ? adapter(source.dynamicGroup) : null,
      filterCondition: source.filterCondition
    }, pickEntityProps(source));
  },
  UserClassifierGroupWithGroupsPopulated: function UserClassifierGroupWithGroupsPopulated(source) {
    return _objectSpread({
      type: 'UserClassifierGroupWithGroupsNode',
      offset: source.offset,
      children: source.children.map(ref),
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      source: source.source,
      dynamicGroup: source.dynamicGroup ? adapter(source.dynamicGroup) : null,
      filterCondition: source.filterCondition
    }, pickEntityProps(source));
  },
  UserClassifierGroupWithElements: function UserClassifierGroupWithElements(source) {
    return _objectSpread({
      type: 'UserClassifierGroupWithElementsNode',
      offset: 0,
      children: [],
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      source: source.source,
      dynamicGroup: source.dynamicGroup ? adapter(source.dynamicGroup) : null,
      filterCondition: source.filterCondition
    }, pickEntityProps(source));
  },
  UserClassifierGroupWithElementsPopulated: function UserClassifierGroupWithElementsPopulated(source) {
    return _objectSpread({
      type: 'UserClassifierGroupWithElementsNode',
      offset: source.offset,
      children: source.children.map(ref),
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      source: source.source,
      dynamicGroup: source.dynamicGroup ? adapter(source.dynamicGroup) : null,
      filterCondition: source.filterCondition
    }, pickEntityProps(source));
  },
  UserClassifierEmptyGroup: function UserClassifierEmptyGroup(source) {
    return _objectSpread({
      type: 'UserClassifierEmptyGroupNode',
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      source: source.source,
      dynamicGroup: source.dynamicGroup ? adapter(source.dynamicGroup) : null,
      filterCondition: source.filterCondition
    }, pickEntityProps(source));
  },
  BimModelReference: function BimModelReference(source) {
    return {
      type: 'BimModelReferenceNode',
      id: source.id,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      element: ref(source.element),
      source: source.source
    };
  },
  BimCategoryReference: function BimCategoryReference(source) {
    return {
      type: 'BimCategoryReferenceNode',
      id: source.id,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      element: ref(source.element),
      source: source.source
    };
  },
  BimFamilyReference: function BimFamilyReference(source) {
    return {
      type: 'BimFamilyReferenceNode',
      id: source.id,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      element: ref(source.element),
      source: source.source
    };
  },
  BimStandardSizeReference: function BimStandardSizeReference(source) {
    return {
      type: 'BimStandardSizeReferenceNode',
      id: source.id,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      element: ref(source.element),
      source: source.source
    };
  },
  BimElementReference: function BimElementReference(source) {
    return {
      type: 'BimElementReferenceNode',
      id: source.id,
      parentClassifierId: source.parentClassifierId,
      parentClassifierVersion: source.parentClassifierVersion,
      parentGroupId: source.parentGroupId,
      element: ref(source.element),
      source: source.source
    };
  },
  BimModel: function (_BimModel) {
    function BimModel(_x8) {
      return _BimModel.apply(this, arguments);
    }

    BimModel.toString = function () {
      return _BimModel.toString();
    };

    return BimModel;
  }(function (source) {
    if (api.BimModel.is(source)) {
      return _objectSpread({
        type: 'BimModelNode',
        version: source.version,
        offset: 0,
        children: [],
        author: source.author,
        status: source.status,
        modelType: source.modelType,
        forgeData: source.forgeData,
        source: source.source,
        uploadDate: source.uploadDate
      }, pickBimModelProps(source));
    }

    return _objectSpread({
      type: 'BimModelNode',
      version: source.version,
      offset: 0,
      children: [],
      author: source.author,
      status: source.status,
      modelType: source.modelType,
      forgeData: source.forgeData,
      source: source.source,
      uploadDate: source.uploadDate,
      errorCode: source.errorCode
    }, pickBimModelNotLoadedProps(source));
  }),
  BimModelPopulated: function BimModelPopulated(source) {
    return _objectSpread({
      type: 'BimModelNode',
      version: source.version,
      offset: source.offset,
      children: source.children.map(ref),
      author: source.author,
      status: source.status,
      modelType: source.modelType,
      forgeData: source.forgeData,
      source: source.source,
      uploadDate: source.uploadDate
    }, pickBimModelProps(source));
  },
  BimCategory: function (_BimCategory) {
    function BimCategory(_x9) {
      return _BimCategory.apply(this, arguments);
    }

    BimCategory.toString = function () {
      return _BimCategory.toString();
    };

    return BimCategory;
  }(function (source) {
    return _objectSpread({
      type: 'BimCategoryNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      source: source.source,
      offset: 0,
      children: [],
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  }),
  BimCategoryPopulated: function BimCategoryPopulated(source) {
    return _objectSpread({
      type: 'BimCategoryNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      offset: source.offset,
      source: source.source,
      children: source.children.map(ref),
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  },
  BimFamily: function (_BimFamily) {
    function BimFamily(_x10) {
      return _BimFamily.apply(this, arguments);
    }

    BimFamily.toString = function () {
      return _BimFamily.toString();
    };

    return BimFamily;
  }(function (source) {
    return _objectSpread({
      type: 'BimFamilyNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      offset: 0,
      source: source.source,
      categoryId: source.categoryId,
      children: [],
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  }),
  BimFamilyPopulated: function BimFamilyPopulated(source) {
    return _objectSpread({
      type: 'BimFamilyNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      offset: source.offset,
      source: source.source,
      categoryId: source.categoryId,
      children: source.children.map(ref),
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  },
  BimStandardSize: function (_BimStandardSize) {
    function BimStandardSize(_x11) {
      return _BimStandardSize.apply(this, arguments);
    }

    BimStandardSize.toString = function () {
      return _BimStandardSize.toString();
    };

    return BimStandardSize;
  }(function (source) {
    return _objectSpread({
      type: 'BimStandardSizeNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      offset: 0,
      source: source.source,
      familyId: source.familyId,
      children: [],
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  }),
  BimStandardSizePopulated: function BimStandardSizePopulated(source) {
    return _objectSpread({
      type: 'BimStandardSizeNode',
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      offset: source.offset,
      source: source.source,
      familyId: source.familyId,
      children: source.children.map(ref),
      isGenerated: source.isGenerated
    }, pickBimEntityProps(source));
  },
  BimElement: function (_BimElement) {
    function BimElement(_x12) {
      return _BimElement.apply(this, arguments);
    }

    BimElement.toString = function () {
      return _BimElement.toString();
    };

    return BimElement;
  }(function (source) {
    return {
      type: 'BimElementNode',
      id: source.id,
      modelId: source.modelId,
      modelVersion: source.modelVersion,
      name: source.name,
      source: source.source,
      forgeRefs: source.forgeRefs,
      viewerRefs: source.viewerRefs,
      standardSizeId: source.standardSizeId,
      total: source.total
    };
  })
};
export function ref(source) {
  var apiEntityType = source.type;
  var nodeType = apiToNodeTypeMap[apiEntityType];
  return {
    type: nodeType,
    id: source.id
  };
}
export var apiToNodeTypeMap = {
  BaseClassifier: 'BaseClassifierNode',
  BaseClassifierPopulated: 'BaseClassifierNode',
  UserClassifierRepository: 'UserClassifierRepoNode',
  UserClassifierRepositoryPopulated: 'UserClassifierRepoNode',
  UserClassifierRepositoryFolder: 'UserClassifierRepoFolderNode',
  UserClassifierRepositoryFolderPopulated: 'UserClassifierRepoFolderNode',
  UserClassifier: 'UserClassifierNode',
  UserClassifierPopulated: 'UserClassifierNode',
  AssemblyClassifier: 'AssemblyClassifierNode',
  AssemblyClassifierPopulated: 'AssemblyClassifierNode',
  AnonymousClassifier: 'AnonymousClassifierNode',
  UserClassifierGroupWithGroups: 'UserClassifierGroupWithGroupsNode',
  UserClassifierGroupWithGroupsPopulated: 'UserClassifierGroupWithGroupsNode',
  UserClassifierGroupWithElements: 'UserClassifierGroupWithElementsNode',
  UserClassifierGroupWithElementsPopulated: 'UserClassifierGroupWithElementsNode',
  UserClassifierEmptyGroup: 'UserClassifierEmptyGroupNode',
  UserClassifierEmptyGroupPopulated: 'UserClassifierEmptyGroupNode',
  UserClassifierGroup: 'UserClassifierGroupNode',
  DynamicBaseGroup: 'DynamicBaseGroupNode',
  DynamicBaseGroupPopulated: 'DynamicBaseGroupNode',
  DynamicBimElementReference: 'DynamicBimElementReferenceNode',
  DynamicGeneratedGroupPopulated: 'DynamicGeneratedGroupNode',
  DynamicGeneratedGroup: 'DynamicGeneratedGroupNode',
  BimModelReference: 'BimModelReferenceNode',
  BimCategoryReference: 'BimCategoryReferenceNode',
  BimFamilyReference: 'BimFamilyReferenceNode',
  BimStandardSizeReference: 'BimStandardSizeReferenceNode',
  BimElementReference: 'BimElementReferenceNode',
  BimModel: 'BimModelNode',
  BimModelPopulated: 'BimModelNode',
  BimCategory: 'BimCategoryNode',
  BimCategoryPopulated: 'BimCategoryNode',
  BimFamily: 'BimFamilyNode',
  BimFamilyPopulated: 'BimFamilyNode',
  BimStandardSize: 'BimStandardSizeNode',
  BimStandardSizePopulated: 'BimStandardSizeNode',
  BimElement: 'BimElementNode'
};
export var nodeToApiTypeMap = {
  BaseClassifierNode: 'BaseClassifier',
  UserClassifierRepoNode: 'UserClassifierRepository',
  UserClassifierRepoFolderNode: 'UserClassifierRepositoryFolder',
  UserClassifierNode: 'UserClassifier',
  AnonymousClassifierNode: 'AnonymousClassifier',
  AssemblyClassifierNode: 'AssemblyClassifier',
  UserClassifierGroupWithGroupsNode: 'UserClassifierGroupWithGroups',
  UserClassifierGroupWithElementsNode: 'UserClassifierGroupWithElements',
  UserClassifierEmptyGroupNode: 'UserClassifierEmptyGroup',
  DynamicBaseGroupNode: 'DynamicBaseGroup',
  DynamicGeneratedGroupNode: 'DynamicGeneratedGroup',
  DynamicBimElementReferenceNode: 'DynamicBimElementReference',
  BimModelReferenceNode: 'BimModelReference',
  BimCategoryReferenceNode: 'BimCategoryReference',
  BimFamilyReferenceNode: 'BimFamilyReference',
  BimStandardSizeReferenceNode: 'BimStandardSizeReference',
  BimElementReferenceNode: 'BimElementReference',
  BimModelNode: 'BimModel',
  BimCategoryNode: 'BimCategory',
  BimFamilyNode: 'BimFamily',
  BimStandardSizeNode: 'BimStandardSize',
  BimElementNode: 'BimElement'
};
export var isGroupType = function isGroupType(type) {
  return type === 'UserClassifierEmptyGroupNode' || type === 'UserClassifierGroupWithElementsNode' || type === 'UserClassifierGroupWithGroupsNode';
};
export var isNotEmptyGroupType = function isNotEmptyGroupType(type) {
  return type === 'UserClassifierGroupWithElementsNode' || type === 'UserClassifierGroupWithGroupsNode';
};
export var isBimType = function isBimType(type) {
  return type === 'BimModelNode' || type === 'BimCategoryNode' || type === 'BimFamilyNode' || type === 'BimStandardSizeNode' || type === 'BimElementNode';
};
export var isBimRefType = function isBimRefType(type) {
  return type === 'BimModelReferenceNode' || type === 'BimCategoryReferenceNode' || type === 'BimFamilyReferenceNode' || type === 'BimStandardSizeReferenceNode' || type === 'BimElementReferenceNode';
};
export var isDynamicType = function isDynamicType(type) {
  return type === 'DynamicBaseGroupNode' || type === 'DynamicBimElementReferenceNode' || type === 'DynamicGeneratedGroupNode';
};
export var isClassifierType = function isClassifierType(type) {
  return type === 'UserClassifierNode' || type === 'AssemblyClassifierNode' || type === 'BaseClassifierNode' || type === 'AnonymousClassifierNode';
};
export var isNodeType = function isNodeType(type) {
  return isGroupType(type) || isBimRefType(type) || isBimType(type) || isDynamicType(type) || isClassifierType(type);
};

var pickEntityProps = function pickEntityProps(source) {
  return {
    id: source.id,
    name: source.name,
    total: source.total
  };
};

var pickBimModelNotLoadedProps = function pickBimModelNotLoadedProps(source) {
  return _objectSpread(_objectSpread({}, pickEntityProps(source)), {}, {
    forgeRefs: source.forgeRefs,
    viewerRefs: source.viewerRefs
  });
};

var pickBimModelProps = function pickBimModelProps(source) {
  return _objectSpread(_objectSpread({}, pickEntityProps(source)), {}, {
    forgeRefs: source.forgeRefs,
    viewerRefs: source.viewerRefs
  });
};

var pickBimEntityProps = function pickBimEntityProps(source) {
  return _objectSpread(_objectSpread({}, pickEntityProps(source)), {}, {
    forgeRefs: source.forgeRefs,
    viewerRefs: source.viewerRefs
  });
};